// Código telefónico (para WhatsApp) según el país del negocio. Multi-país: se
// usa para anteponer el código a los números LOCALES (sin +). Los números que
// ya traen su + (internacionales) se respetan tal cual.

const CODIGOS = {
  honduras: '504',
  guatemala: '502',
  'el salvador': '503', salvador: '503',
  nicaragua: '505',
  'costa rica': '506',
  panama: '507',
  mexico: '52',
  'estados unidos': '1', usa: '1', eeuu: '1', 'united states': '1', 'estados unidos de america': '1', 'ee uu': '1',
  canada: '1',
  'puerto rico': '1',
  'republica dominicana': '1', dominicana: '1',
  colombia: '57',
  espana: '34', spain: '34',
  argentina: '54',
  chile: '56',
  peru: '51',
  ecuador: '593',
  venezuela: '58',
  bolivia: '591',
  paraguay: '595',
  uruguay: '598',
  brasil: '55', brazil: '55',
};

// Normaliza: minúsculas, sin acentos, sin espacios extra.
function norm(s) {
  return String(s || '')
    .toLowerCase().trim()
    .normalize('NFD').replace(/[̀-ͯ]/g, '');
}

// Devuelve el código telefónico del país. Si no se reconoce, 504 (Honduras) por
// compatibilidad con los negocios actuales.
export function codigoTelefonoPorPais(pais) {
  return CODIGOS[norm(pais)] || '504';
}

// Zonas horarias comunes (para el corte del día / cierre de mes por negocio).
export const ZONAS_HORARIAS = [
  { tz: 'America/Tegucigalpa', label: 'Centroamérica — Honduras, Guatemala, El Salvador, Nicaragua, Costa Rica (UTC-6)' },
  { tz: 'America/Mexico_City', label: 'México — Centro (UTC-6)' },
  { tz: 'America/Panama', label: 'Panamá, Colombia, Perú, Ecuador (UTC-5)' },
  { tz: 'America/New_York', label: 'USA — Este / New York, Miami (UTC-5/-4)' },
  { tz: 'America/Chicago', label: 'USA — Centro / Chicago, Houston (UTC-6/-5)' },
  { tz: 'America/Denver', label: 'USA — Montaña / Denver (UTC-7/-6)' },
  { tz: 'America/Los_Angeles', label: 'USA — Pacífico / Los Ángeles (UTC-8/-7)' },
  { tz: 'America/Santo_Domingo', label: 'Rep. Dominicana, Puerto Rico (UTC-4)' },
  { tz: 'America/Argentina/Buenos_Aires', label: 'Argentina, Uruguay (UTC-3)' },
  { tz: 'America/Santiago', label: 'Chile (UTC-4/-3)' },
  { tz: 'Europe/Madrid', label: 'España (UTC+1/+2)' },
];

// Zona horaria sugerida según el país (respaldo Honduras).
const TZ_POR_PAIS = {
  mexico: 'America/Mexico_City', 'estados unidos': 'America/New_York', usa: 'America/New_York',
  eeuu: 'America/New_York', panama: 'America/Panama', colombia: 'America/Panama',
  peru: 'America/Panama', ecuador: 'America/Panama',
  'republica dominicana': 'America/Santo_Domingo', dominicana: 'America/Santo_Domingo',
  'puerto rico': 'America/Santo_Domingo',
  argentina: 'America/Argentina/Buenos_Aires', uruguay: 'America/Argentina/Buenos_Aires',
  chile: 'America/Santiago', espana: 'Europe/Madrid', spain: 'Europe/Madrid',
};
export function zonaHorariaPorPais(pais) {
  return TZ_POR_PAIS[norm(pais)] || 'America/Tegucigalpa';
}

// Moneda oficial según el país del negocio (multi-país). Los países dolarizados
// (El Salvador, Panamá, Ecuador, Puerto Rico) devuelven USD a propósito.
const MONEDA_POR_PAIS = {
  honduras: 'HNL',
  guatemala: 'GTQ',
  'el salvador': 'USD', salvador: 'USD',
  nicaragua: 'NIO',
  'costa rica': 'CRC',
  panama: 'USD',
  mexico: 'MXN',
  'estados unidos': 'USD', usa: 'USD', eeuu: 'USD', 'united states': 'USD', 'estados unidos de america': 'USD', 'ee uu': 'USD',
  canada: 'CAD',
  'puerto rico': 'USD',
  'republica dominicana': 'DOP', dominicana: 'DOP',
  colombia: 'COP',
  espana: 'EUR', spain: 'EUR',
  argentina: 'ARS',
  chile: 'CLP',
  peru: 'PEN',
  ecuador: 'USD',
  venezuela: 'USD',
  bolivia: 'BOB',
  paraguay: 'PYG',
  uruguay: 'UYU',
  brasil: 'BRL', brazil: 'BRL',
};

// Devuelve el código de moneda del país. Si no se reconoce, null (para no
// pisar la moneda que ya tenga el negocio).
export function monedaPorPais(pais) {
  return MONEDA_POR_PAIS[norm(pais)] || null;
}

// Etiqueta amigable de una moneda (para menús). Respaldo: el propio código.
const MONEDA_LABEL = {
  HNL: 'Lempira (HNL)', USD: 'Dólar (USD)', GTQ: 'Quetzal (GTQ)', NIO: 'Córdoba (NIO)',
  CRC: 'Colón (CRC)', MXN: 'Peso mexicano (MXN)', COP: 'Peso colombiano (COP)',
  DOP: 'Peso dominicano (DOP)', EUR: 'Euro (EUR)', ARS: 'Peso argentino (ARS)',
  CLP: 'Peso chileno (CLP)', PEN: 'Sol (PEN)', BOB: 'Boliviano (BOB)',
  PYG: 'Guaraní (PYG)', UYU: 'Peso uruguayo (UYU)', BRL: 'Real (BRL)', CAD: 'Dólar canadiense (CAD)',
};

// Lista de monedas para menús desplegables (código + etiqueta).
export const MONEDAS = Object.keys(MONEDA_LABEL).map((codigo) => ({ codigo, label: MONEDA_LABEL[codigo] }));

export function monedaLabel(codigo) {
  return MONEDA_LABEL[codigo] || codigo;
}
